import React, { useState, useEffect, useRef } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // ZMIANA: HashRouter
import CookieConsent from "react-cookie-consent";
import Logo from './logo2.svg';
import 'flag-icons/css/flag-icons.min.css';
import Logotyp from './logotyp.svg';
import Logotyp2 from './NOVApodroze.svg';
import Logotyp3 from './logotyp3.svg';
import PolitykaPrywatnosci from './PolitykaPrywatnosci'; // DODAJ IMPORT

// KOMPONENT APP Z ROUTEREM
const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NovaHLS />} />
        <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
        <Route path="*" element={<NovaHLS />} />
      </Routes>
    </Router>
  );
};

const NovaHLS: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState<'PL' | 'DE' | 'EN'>('PL');
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState({
    hero: false,
    services: false,
    about: false,
    projects: false,
    contact: false
  });
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentLightboxImage, setCurrentLightboxImage] = useState('');
  const [lightboxImages, setLightboxImages] = useState<string[]>([]);

  const observerRefs = {
    hero: useRef(null),
    services: useRef(null),
    about: useRef(null),
    projects: useRef(null),
    contact: useRef(null)
  };

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);

  const galleryImages = [
    require('./remont1.jpg'),
    require('./remont2.jpeg'),
    require('./remont3.jpg'),
    require('./remont4.jpg'),
    require('./lazienka.jpg'),
    require('./remont5.jpg'),
    require('./remont6.jpg'),
    require('./remont7.jpg'),
    require('./ogrzewanie.jpg'),
    require('./elektryka.jpg'),
    require('./remont8.jpg'),
    require('./remont9.jpg'),
    require('./remont10.jpg'),
    require('./remont11.jpg'),
    require('./remont12.jpg'),
    require('./ogrzewanie2.jpg'),
    require('./ogrzewanie3.jpg'),
    require('./ogrzewanie4.jpg'),
    require('./remont13.jpg'),
    require('./remont14.jpg'),
    require('./remont15.jpg'),
    require('./remont16.jpg'),
    require('./remont17.jpg'),
    require('./remont18.jpg')
  ];

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };
    
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target.getAttribute('data-section');
          if (section) {
            setIsVisible(prev => ({ ...prev, [section]: true }));
          }
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    Object.keys(observerRefs).forEach(key => {
      if (observerRefs[key as keyof typeof observerRefs].current) {
        observer.observe(observerRefs[key as keyof typeof observerRefs].current!);
      }
    });
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const toggleLangDropdown = () => setIsLangDropdownOpen(!isLangDropdownOpen);
  const selectLanguage = (lang: 'PL' | 'DE' | 'EN') => {
    setCurrentLanguage(lang);
    setIsLangDropdownOpen(false);
  };

  const openLightbox = (image: string, images: string[], index: number = 0) => {
    setCurrentLightboxImage(images[index]);
    setLightboxImages(images);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
    setCurrentLightboxImage('');
    setLightboxImages([]);
  };

  const navigateLightbox = (direction: 'next' | 'prev') => {
    const currentIndex = lightboxImages.indexOf(currentLightboxImage);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % lightboxImages.length;
    } else {
      newIndex = (currentIndex - 1 + lightboxImages.length) % lightboxImages.length;
    }
    
    setCurrentLightboxImage(lightboxImages[newIndex]);
  };

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    if (targetId === '#') return;
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.getBoundingClientRect().top + window.pageYOffset - 80,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      setIsFormSubmitted(true);
      
      setTimeout(() => setIsFormSubmitted(false), 5000);
    }, 1500);
  };

  const translations = {
    PL: {
      nav: { home: "Strona Główna", services: "Usługi", projects: "Realizacje", about: "O Nas", contact: "Kontakt", quote: "Wycena" },
      hero: { title: "NOVA HLS", subtitle: "Usługi remontowe i instalacyjne", servicesBtn: "Poznaj nasze usługi", contactBtn: "Skontaktuj się" },
      services: { title: "Nasze Usługi", description: "Oferujemy kompleksowe usługi remontowe i instalacyjne dla Twojego domu lub mieszkania.",
        plumbing: { title: "Hydraulika", description: "Kompleksowe usługi hydrauliczne - instalacja, naprawa i konserwacja systemów wodno-kanalizacyjnych.", items: ["Instalacje wodno-kanalizacyjne","Wymiana armatury","Usuwanie awarii","Montaż urządzeń sanitarnych"] },
        electrical: { title: "Elektryka", description: "Profesjonalne usługi elektryczne, zapewniające bezpieczeństwo i funkcjonalność.", items: ["Instalacje elektryczne","Montaż oświetlenia","Naprawy awarii","Modernizacja instalacji"] },
        heating: { title: "Ogrzewanie i wentylacja", description: "Instalacja i serwis systemów grzewczych i wentylacji dla Twojego domu lub mieszkania.", items: ["Instalacja kotłów","Montaż grzejników","Systemy podłogowego ogrzewania","Przeglądy i serwis"] },
        bathrooms: { title: "Remonty Łazienek", description: "Kompleksowe remonty łazienek od projektu po wykonanie, z dbałością o każdy detal.", items: ["Projektowanie łazienek od A do Z","Układanie płytek","Montaż mebli łazienkowych","Kompleksowe wykończenie"] }
      },
      about: { title: "O Nas", description1: "NOVA HLS to firma z wieloletnim doświadczeniem w branży remontowej i instalacyjnej.", description2: "Nasz zespół składa się z wykwalifikowanych specjalistów, którzy dbają o najwyższą jakość wykonywanych usług i satysfakcję klientów.", quality: "Gwarancja jakości", qualityDesc: "Na wszystkie usługi", speed: "Szybka realizacja", speedDesc: "Terminowe wykonanie", experience: "Doświadczenie", experienceDesc: "Ponad 7 lat na rynku" },
      projects: { title: "Nasze ostatnie realizacje", description: "Zobacz przykłady naszych prac i przekonaj się o jakości naszych usług.", items: [
        {title:"Odwierty pod wentylację",description:"Wykonanie odwiertów na mokro otwornicą diamentową w ścianie z kamienia i cegły"},
        {title:"Remont generalny łazienki",description:"Kompletny remont łazienki z wymianą wszystkich instalacji"},
        {title:"Instalacja hydrauliczna",description:"Nowa instalacja wodno-kanalizacyjna w domu jednorodzinnym"},
        {title:"System ogrzewania",description:"Montaż nowoczesnego systemu ogrzewania podłogowego"},
        {title:"Elektryka",description:"Modernizacja instalacji elektrycznej w mieszkaniu"}
      ] },
      contact: { title: "Kontakt", description: "Skontaktuj się z nami, aby omówić swój projekt.", infoTitle:"Kontakt", phone:"Telefon", email:"Email", address:"Dane firmy", formTitle:"Wyślij wiadomość", name:"Imię i nazwisko", message:"Wiadomość", send:"Wyślij wiadomość" },
      footer: { description: "Profesjonalne usługi remontowe i instalacyjne.", services: "Usługi", company: "Firma", hours: "Godziny otwarcia", rights: "Wszelkie prawa zastrzeżone. Strona autorstwa Michał Szczepański" }
    },
    DE: {
      nav: { home: "Startseite", services: "Dienstleistungen", projects: "Projekte", about: "Über uns", contact: "Kontakt", quote: "Angebot" },
      hero: { title: "NOVA HLS", subtitle: "Umfassende Renovierungs- und Installationsdienstleistungen", servicesBtn: "Unsere Dienstleistungen", contactBtn: "Kontakt aufnehmen" },
      services: { title: "Unsere Dienstleistungen", description: "Wir bieten umfassende Renovierungs- und Installationsdienstleistungen.",
        plumbing: { title: "Sanitär", description: "Umfassende Sanitärdienstleistungen", items: ["Wasser- und Abwasserinstallationen","Armaturenaustausch","Störungsbehebung","Installation von Sanitäreinrichtungen"] },
        electrical: { title: "Elektrik", description: "Professionelle Elektrodienstleistungen", items: ["Elektroinstallationen","Beleuchtungsmontage","Störungsbehebungen","Anlagenmodernisierung"] },
        heating: { title: "Heizung und Luftung", description: "Installation und Service von Heizsystemen und Luftungsystemen.", items: ["Kesselinstallation","Heizkörpermontage","Fußbodenheizungssysteme","Inspektionen und Service"] },
        bathrooms: { title: "Badezimmerrenovierungen", description: "Umfassende Badezimmerrenovierungen.", items: ["Badezimmerplanung von A bis Z","Fliesenverlegung","Montage von Badezimmermöbeln","Umfassende Fertigstellung"] }
      },
      about: { title: "Über uns", description1: "NOVA HLS ist ein Unternehmen mit langjähriger Erfahrung.", description2: "Unser Team besteht aus qualifizierten Fachleuten.", quality:"Qualitätsgarantie", qualityDesc:"Für alle Dienstleistungen", speed:"Schnelle Umsetzung", speedDesc:"Termingerechte Ausführung", experience: "Erfahrung", experienceDesc: "Über 15 Jahre am Markt" },
      projects: { title: "Unsere Projekte", description:"Sehen Sie sich Beispiele unserer Arbeiten an.", items: [
        {title:"Bohrarbeiten für Belüftung",description:"Bohrarbeiten mit Diamantkronenbohrung in Stein- und Ziegelwänden"},
        {title:"Komplette Badezimmerrenovierung",description:"Komplette Renovierung des Badezimmers mit Austausch aller Installationen"},
        {title:"Sanitärinstallation",description:"Neue Installation"},
        {title:"Heizungssystem",description:"Installation eines modernen Heizsystems"},
        {title:"Elektrik",description:"Modernisierung der Elektroinstallation"}
      ] },
      contact: { title:"Kontakt", description:"Kontaktieren Sie uns.", infoTitle:"Kontakt", phone:"Telefon", email:"E-Mail", address:"Firmendetails", formTitle:"Nachricht senden", name:"Vor- und Nachname", message:"Nachricht", send:"Nachricht senden" },
      footer: { description:"Professionelle Renovierungs- und Installationsdienstleistungen.", services:"Dienstleistungen", company:"Firma", hours: "Öffnungszeiten", rights:"Alle Rechte vorbehalten. Seite erstellt von Michal Szczepanski" }
    },
    EN: {
      nav: { home: "Home", services: "Services", projects: "Projects", about: "About", contact: "Contact", quote: "Quote" },
      hero: { title: "NOVA HLS", subtitle: "Comprehensive renovation and installation services", servicesBtn: "Our Services", contactBtn: "Contact Us" },
      services: { title: "Our Services", description: "We provide comprehensive renovation and installation services.",
        plumbing: { title: "Plumbing", description: "Comprehensive plumbing services", items:["Water and sewage installations","Fixture replacement","Fault repair","Sanitary equipment installation"] },
        electrical: { title:"Electrical", description:"Professional electrical services", items:["Electrical installations","Lighting installation","Fault repairs","System modernization"] },
        heating: { title:"Heating and ventilation", description:"Heating and ventilation system installation and service", items:["Boiler installation","Radiator installation","Underfloor heating","Inspections and service"] },
        bathrooms: { title: "Bathroom Renovations", description:"Comprehensive bathroom renovations", items:["Full bathroom design","Tile installation","Bathroom furniture installation","Complete finishing"] }
      },
      about: { title:"About", description1:"NOVA HLS is a company with many years of experience.", description2:"Our team consists of qualified professionals.", quality:"Quality guarantee", qualityDesc:"For all services", speed:"Fast execution", speedDesc:"On-time delivery", experience: "Experience", experienceDesc: "Over 15 years in the market" },
      projects: { title:"Our Projects", description:"See examples of our work.", items: [
        {title:"Ventilation drilling",description:"Wet drilling with diamond core drilling in stone and brick walls"},
        {title:"Complete bathroom renovation",description:"Complete bathroom renovation with replacement of all installations"},
        {title:"Plumbing Installation",description:"New plumbing installation"},
        {title:"Heating System",description:"Modern heating system installation"},
        {title:"Electrical",description:"Electrical system modernization"}
      ] },
      contact: { title:"Contact", description:"Get in touch with us.", infoTitle:"Contact", phone:"Phone", email:"Email", address:"Company details", formTitle:"Send a message", name:"Name", message:"Message", send:"Send Message" },
      footer: { description:"Professional renovation and installation services.", services:"Services", company:"Company", hours: "Opening Hours", rights:"All rights reserved. Site by Michal Szczepanski" }
    }
  };

  const t = translations[currentLanguage];

  const ListItem: React.FC<{ item: string }> = ({ item }) => (
    <li className="flex items-center opacity-80 group-hover:opacity-100 transition-opacity duration-300">
      <i className="fas fa-check text-blue-600 mr-2 transform group-hover:scale-110 transition-transform duration-300"></i>
      <span className="text-gray-700">{item}</span>
    </li>
  );

  const ServiceCard: React.FC<{ icon: string; title: string; description: string; items: string[] }> = ({ icon, title, description, items }) => (
    <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 border border-gray-200 hover:-translate-y-2 group cursor-pointer">
      <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform duration-300">{icon}</div>
      <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <ul className="space-y-2">{items.map((item,i)=><ListItem key={i} item={item} />)}</ul>
    </div>
  );

  const ProjectCard: React.FC<{ icon:string; title:string; description:string }> = ({icon,title,description}) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-500 border border-gray-200 group">
      <div className="h-48 project-image flex items-center justify-center text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 opacity-90 group-hover:opacity-70 transition-opacity duration-500"></div>
        <i className={`${icon} text-5xl relative z-10 group-hover:scale-125 transition-transform duration-500`}></i>
        <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
      </div>
      <div className="p-4 group-hover:bg-gray-50 transition-colors duration-300">
        <h3 className="font-bold text-lg mb-2 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-50">
      {/* Loading Screen */}
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-blue-600 z-50 transition-opacity duration-500">
          <div className="relative">
            <div className="w-24 h-24 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            <img src={Logotyp} alt="NOVA HLS" className="h-8 w-auto absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 filter invert brightness-200" />
          </div>
        </div>
      )}

      {/* Header */}
      <header className={`fixed w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-gray-900 shadow-xl py-2' : 'bg-transparent py-4'}`}>
        <div className="container mx-auto px-4 flex justify-between items-center">
          <a href="#" onClick={(e)=>{e.preventDefault(); window.scrollTo({top:0,behavior:'smooth'});}} className="flex items-center">
            <img src={Logo} alt="NOVA HLS" className="h-16 md:h-20 w-auto filter brightness-0 invert"/>
          </a>

          <nav className="hidden md:flex space-x-8 items-center">
            <a href="#" className={`font-medium transition-colors ${isScrolled ? 'text-white hover:text-blue-400' : 'text-white hover:text-blue-300'}`}>{t.nav.home}</a>
            <a href="#uslugi" onClick={(e)=>handleSmoothScroll(e,'#uslugi')} className={`font-medium transition-colors ${isScrolled ? 'text-white hover:text-blue-400' : 'text-white hover:text-blue-300'}`}>{t.nav.services}</a>
            <a href="#realizacje" onClick={(e)=>handleSmoothScroll(e,'#realizacje')} className={`font-medium transition-colors ${isScrolled ? 'text-white hover:text-blue-400' : 'text-white hover:text-blue-300'}`}>{t.nav.projects}</a>
            <a href="#onas" onClick={(e)=>handleSmoothScroll(e,'#onas')} className={`font-medium transition-colors ${isScrolled ? 'text-white hover:text-blue-400' : 'text-white hover:text-blue-300'}`}>{t.nav.about}</a>
            <a href="#kontakt" onClick={(e)=>handleSmoothScroll(e,'#kontakt')} className={`font-medium transition-colors ${isScrolled ? 'text-white hover:text-blue-400' : 'text-white hover:text-blue-300'}`}>{t.nav.contact}</a>

            <div className="relative">
              <button onClick={toggleLangDropdown} className={`flex items-center gap-2 px-3 py-1 rounded transition-colors ${isScrolled ? 'border border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-gray-900' : 'border border-white text-white hover:bg-white hover:text-gray-900'}`}>
                {currentLanguage==='PL' && <span className="fi fi-pl"></span>}
                {currentLanguage==='DE' && <span className="fi fi-de"></span>}
                {currentLanguage==='EN' && <span className="fi fi-gb"></span>}
                {currentLanguage}
                <i className="fas fa-chevron-down ml-1"></i>
              </button>
              {isLangDropdownOpen && (
                <div className="absolute right-0 mt-1 w-32 bg-white rounded shadow-xl z-50 border border-gray-200">
                  <button onClick={()=>selectLanguage('PL')} className="flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 transition-colors">
                    <span className="fi fi-pl"></span> PL
                  </button>
                  <button onClick={()=>selectLanguage('DE')} className="flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 transition-colors">
                    <span className="fi fi-de"></span> DE
                  </button>
                  <button onClick={()=>selectLanguage('EN')} className="flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 transition-colors">
                    <span className="fi fi-gb"></span> EN
                  </button>
                </div>
              )}
            </div>

            <a href="#kontakt" onClick={(e)=>handleSmoothScroll(e,'#kontakt')} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5">{t.nav.quote}</a>
          </nav>

          <div className="md:hidden flex items-center">
            <button onClick={toggleMobileMenu} className={`${isScrolled ? 'text-white' : 'text-white'}`}>
              <i className="fas fa-bars text-xl"></i>
            </button>
          </div>
        </div>

        <div className={`${isMobileMenuOpen?'max-h-96 opacity-100 py-4':'max-h-0 opacity-0 py-0'} md:hidden bg-gray-900 shadow-lg overflow-hidden transition-all duration-300 ease-in-out`}>
          <div className="container mx-auto px-4 flex flex-col space-y-4">
            <div className="flex justify-center">
              <img src={Logo} alt="NOVA HLS" className="h-14 w-auto filter brightness-0 invert"/>
            </div>
            
            <a href="#" className="font-medium text-white hover:text-blue-400 transition-colors py-2" onClick={() => setIsMobileMenuOpen(false)}>{t.nav.home}</a>
            <a href="#uslugi" onClick={(e)=>{handleSmoothScroll(e,'#uslugi'); setIsMobileMenuOpen(false);}} className="font-medium text-white hover:text-blue-400 transition-colors py-2">{t.nav.services}</a>
            <a href="#realizacje" onClick={(e)=>{handleSmoothScroll(e,'#realizacje'); setIsMobileMenuOpen(false);}} className="font-medium text-white hover:text-blue-400 transition-colors py-2">{t.nav.projects}</a>
            <a href="#onas" onClick={(e)=>{handleSmoothScroll(e,'#onas'); setIsMobileMenuOpen(false);}} className="font-medium text-white hover:text-blue-400 transition-colors py-2">{t.nav.about}</a>
            <a href="#kontakt" onClick={(e)=>{handleSmoothScroll(e,'#kontakt'); setIsMobileMenuOpen(false);}} className="font-medium text-white hover:text-blue-400 transition-colors py-2">{t.nav.contact}</a>
            
            <div className="flex justify-center py-2">
              <a href="https://podroze.novahls.pl">
                <img src={Logotyp2} alt="NOVA Podróże" className="h-12 w-auto filter brightness-0 invert"/>
              </a>
            </div>
            
            <div className="flex space-x-4 justify-center py-2">
              <button onClick={()=>selectLanguage('PL')} className={`px-3 py-1 rounded transition-colors ${currentLanguage === 'PL' ? 'bg-blue-600 text-white' : 'bg-gray-700 text-white hover:bg-gray-600'}`}>PL</button>
              <button onClick={()=>selectLanguage('DE')} className={`px-3 py-1 rounded transition-colors ${currentLanguage === 'DE' ? 'bg-blue-600 text-white' : 'bg-gray-700 text-white hover:bg-gray-600'}`}>DE</button>
              <button onClick={()=>selectLanguage('EN')} className={`px-3 py-1 rounded transition-colors ${currentLanguage === 'EN' ? 'bg-blue-600 text-white' : 'bg-gray-700 text-white hover:bg-gray-600'}`}>EN</button>
            </div>
            <a href="#kontakt" onClick={(e)=>{handleSmoothScroll(e,'#kontakt'); setIsMobileMenuOpen(false);}} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors text-center transform hover:-translate-y-0.5">{t.nav.quote}</a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
<section
  ref={observerRefs.hero}
  data-section="hero"
  className="pt-20 hero-bg min-h-[110vh] md:h-screen flex items-center justify-center text-white overflow-hidden relative"
>
  <div className="absolute inset-0 bg-black opacity-50"></div>

  <div className="container mx-auto px-4 relative z-10">
    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between gap-8 md:gap-16">
      {/* Pierwszy logotyp - NOVA HLS */}
      <div className="flex flex-col items-center justify-center md:w-2/5">
        <div className={`transform transition-all duration-1000 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        } flex justify-center mb-4`}>
          <img src={Logotyp} alt="NOVA HLS" className="h-20 md:h-28 w-auto filter brightness-0 invert" />
        </div>
        <p className={`text-xl md:text-2xl text-white text-center transform transition-all duration-1000 delay-500 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          {t.hero.subtitle}
        </p>
        <a
          href="#uslugi"
          onClick={(e) => handleSmoothScroll(e, '#uslugi')}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 mt-4"
        >
          Poznaj nasze usługi remontowe
        </a>
      </div>
      
      <div className="hidden md:block h-40 w-px bg-white bg-opacity-50 mx-4"></div>
      
      {/* Drugi logotyp - NOVA Podróże */}
      <div className="flex flex-col items-center justify-center md:w-2/5">
        <div className={`transform transition-all duration-1000 delay-300 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        } flex justify-center mb-4`}>
          <img src={Logotyp2} alt="NOVA Podróże" className="h-24 md:h-32 w-auto filter brightness-0 invert" />
        </div>
        <p className={`text-xl md:text-2xl text-white text-center transform transition-all duration-1000 delay-700 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          Organizacja podróży
        </p>
        <a
          href="https://podroze.novahls.pl"
          className="border-2 border-white text-white px-6 py-2 rounded-lg font-medium hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:-translate-y-1 mt-4"
          target="_blank"
          rel="noopener noreferrer"
        >
          Zorganizuj z nami wycieczkę marzeń
        </a>
      </div>
      
      <div className="hidden md:block h-40 w-px bg-white bg-opacity-50 mx-4"></div>
      
      {/* Trzeci logotyp - Logotyp3 */}
      <div className="flex flex-col items-center justify-center md:w-2/5">
        <div className={`transform transition-all duration-1000 delay-500 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        } flex justify-center mb-4`}>
          <img src={Logotyp3} alt="NOVA" className="h-20 md:h-28 w-auto filter brightness-0 invert" />
        </div>
        <p className={`text-xl md:text-2xl text-white text-center transform transition-all duration-1000 delay-900 ${
          isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          Projektowanie stron internetowych
        </p>
        <a
          href="https://witryny.novahls.pl"
          className="border-2 border-white text-white px-6 py-2 rounded-lg font-medium hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:-translate-y-1 mt-4"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stwórz własną, wymarzoną stronę
        </a>
      </div>
    </div>
  </div>

  <div className="absolute -bottom-16 md:bottom-0 left-1/2 transform -translate-x-1/2">
    <div className="animate-bounce">
      <div className="w-6 h-9 border-2 border-white rounded-full flex justify-center">
        <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
      </div>
    </div>
  </div>



</section>

      {/* About Section */}

      <section id="onas" ref={observerRefs.about} data-section="about" className="py-20 bg-white relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute -right-32 -top-32 w-64 h-64 bg-blue-100 rounded-full opacity-30"></div>
        <div className="absolute -left-32 -bottom-32 w-64 h-64 bg-blue-200 rounded-full opacity-20"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <div className={`transform transition-all duration-700 ${isVisible.about ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">{t.about.title}</h2>
                <p className="text-gray-600 mb-4">
                  {t.about.description1}
                </p>
                <p className="text-gray-600 mb-4">
                  {t.about.description2}
                </p>
                <div className="flex flex-wrap gap-6 mt-8">
                  {[
                    { icon: "fas fa-shield-alt", title: t.about.quality, desc: t.about.qualityDesc },
                    { icon: "fas fa-bolt", title: t.about.speed, desc: t.about.speedDesc },
                    { icon: "fas fa-award", title: t.about.experience, desc: t.about.experienceDesc }
                  ].map((item, index) => (
                    <div key={index} className="flex items-center bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                      <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <i className={`${item.icon} text-blue-600`}></i>
                      </div>
                      <div>
                        <p className="font-bold text-gray-900">{item.title}</p>
                        <p className="text-sm text-gray-500">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* GALERIA PROJEKTÓW - ZAMIAT OBRAZU ZESPOŁU */}
            <div className="md:w-1/2">
              <div className={`transform transition-all duration-700 ${isVisible.about ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'}`}>
                <h3 className="text-xl font-bold mb-6 text-center text-gray-900">Zdjęcia z budowy</h3>
                
            {/* Miniatury galerii */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              {[
                require('./remont15.jpg'),
                require('./remont16.jpg'),
                require('./remont17.jpg'),
                require('./remont18.jpg')
              ].map((image, index) => (
                <div 
                  key={index}
                  className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-500"
                  onClick={() => openLightbox(image, galleryImages, index)}
                >
                  <img 
                    src={image} 
                    alt={`Projekt ${index + 1}`}
                    className="w-full h-32 object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                    <i className="fas fa-search-plus text-white text-xl opacity-0 group-hover:opacity-100 transform scale-90 group-hover:scale-110 transition-all duration-300"></i>
                  </div>
                </div>
              ))}
            </div>
                
                <p className="text-center text-gray-600 text-sm">
                  Kliknij, aby zobaczyć więcej naszych realizacji
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* MODAL Z PEŁNĄ GALERIĄ */}
        {isGalleryOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
            <button 
              onClick={() => setIsGalleryOpen(false)}
              className="absolute top-4 right-4 text-white text-3xl z-50 hover:text-blue-400 transition-colors"
              aria-label="Zamknij galerię"
            >
              <i className="fas fa-times"></i>
            </button>
            
            <div className="relative w-full max-w-6xl">
              {/* Główny obraz */}
              <div className="relative">
                <img 
                  src={galleryImages[currentGalleryIndex]} 
                  alt={`Galeria projektów ${currentGalleryIndex + 1}`}
                  className="w-full h-96 object-contain rounded-lg"
                />
              </div>
              
              {/* Nawigacja */}
              <button 
                onClick={() => setCurrentGalleryIndex(prev => prev === 0 ? galleryImages.length - 1 : prev - 1)}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-70 transition-all"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              
              <button 
                onClick={() => setCurrentGalleryIndex(prev => prev === galleryImages.length - 1 ? 0 : prev + 1)}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-70 transition-all"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
              
              {/* Miniatury pod głównym obrazem */}
              <div className="flex justify-center mt-4 space-x-2">
                {galleryImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Miniatura ${index + 1}`}
                    className={`w-16 h-12 object-cover cursor-pointer rounded border-2 transition-all ${
                      index === currentGalleryIndex ? 'border-blue-500 scale-110' : 'border-transparent opacity-70 hover:opacity-100'
                    }`}
                    onClick={() => setCurrentGalleryIndex(index)}
                  />
                ))}
              </div>
              
              {/* Numeracja */}
              <div className="text-white text-center mt-2">
                {currentGalleryIndex + 1} / {galleryImages.length}
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Projects Section */}
      <section id="realizacje" ref={observerRefs.projects} data-section="projects" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className={`text-center mb-16 transform transition-all duration-700 ${isVisible.projects ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">{t.projects.title}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{t.projects.description}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {t.projects.items.slice(0, 3).map((item, index) => {
              const images = [
                require('./odwierty.jpg'),
                require('./lazienka.jpg'),
                require('./remont6.jpg'),
                require('./ogrzewanie3.jpg'),
                require('./elektryka.jpg')
              ];
              
              return (
                <div 
                  key={index} 
                  className={`transform transition-all duration-700 delay-${index * 100} ${isVisible.projects ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
                >
                  <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-500 border border-gray-200 group cursor-pointer"
                    onClick={() => openLightbox(images[index], images, index)}>
                    <div className="h-48 project-image flex items-center justify-center text-white relative overflow-hidden">
                      <img 
                        src={images[index]} 
                        alt={item.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 opacity-30 group-hover:opacity-10 transition-opacity duration-500"></div>
                      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <i className="fas fa-search-plus text-white text-3xl bg-black bg-opacity-50 p-3 rounded-full"></i>
                      </div>
                    </div>
                    <div className="p-4 group-hover:bg-gray-50 transition-colors duration-300">
                      <h3 className="font-bold text-lg mb-2 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Druga linia - 2 projekty */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {t.projects.items.slice(3, 5).map((item, index) => {
              const images = [
                require('./odwierty.jpg'),
                require('./lazienka.jpg'),
                require('./remont6.jpg'),
                require('./ogrzewanie3.jpg'),
                require('./elektryka.jpg')
              ];
              const actualIndex = index + 3; // +3 bo bierzemy projekty od indeksu 3
              
              return (
                <div 
                  key={actualIndex} 
                  className={`transform transition-all duration-700 delay-${(index + 3) * 100} ${isVisible.projects ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
                >
                  <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-500 border border-gray-200 group cursor-pointer"
                    onClick={() => openLightbox(images[actualIndex], images, actualIndex)}>
                    <div className="h-48 project-image flex items-center justify-center text-white relative overflow-hidden">
                      <img 
                        src={images[actualIndex]} 
                        alt={item.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 opacity-30 group-hover:opacity-10 transition-opacity duration-500"></div>
                      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <i className="fas fa-search-plus text-white text-3xl bg-black bg-opacity-50 p-3 rounded-full"></i>
                      </div>
                    </div>
                    <div className="p-4 group-hover:bg-gray-50 transition-colors duration-300">
                      <h3 className="font-bold text-lg mb-2 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="kontakt" ref={observerRefs.contact} data-section="contact" className="py-20 bg-white relative">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-blue-100 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-blue-100 to-transparent"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className={`text-center mb-16 transform transition-all duration-700 ${isVisible.contact ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">{t.contact.title}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{t.contact.description}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className={`transform transition-all duration-700 ${isVisible.contact ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
              <h3 className="text-2xl font-bold mb-6 text-gray-900">{t.contact.infoTitle}</h3>
              <div className="space-y-6">
                <div className="flex items-start p-4 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="fas fa-phone text-blue-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{t.contact.phone}</p>
                    <p className="text-gray-600">+48 534 926 285</p>
                  </div>
                </div>
                <div className="flex items-start p-4 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="fas fa-envelope text-blue-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{t.contact.email}</p>
                    <p className="text-gray-600">biuro@novahls.pl</p>
                  </div>
                </div>
                <div className="flex items-start p-4 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="fas fa-map-marker-alt text-blue-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{t.contact.address}</p>
                    <p className="text-gray-600">Adres: ul. Stanisławowska 47, 54-611 Wrocław, Polska</p>
                    <p className="text-gray-600">NIP: 8943267784</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`transform transition-all duration-700 ${isVisible.contact ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'}`}>
              <h3 className="text-2xl font-bold mb-6 text-gray-900">{t.contact.formTitle}</h3>
              
              {isFormSubmitted ? (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                  <p className="font-medium">Dziękujemy za wiadomość!</p>
                  <p className="text-sm">Odpowiemy tak szybko, jak to możliwe.</p>
                </div>
              ) : (
                <form className="space-y-4" onSubmit={handleSubmit}>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t.contact.name}</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                      required 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                      required 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t.contact.message}</label>
                    <textarea 
                      rows={4} 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                      required
                    ></textarea>
                  </div>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`}
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center">
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        Wysyłanie...
                      </span>
                    ) : (
                      t.contact.send
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

            {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="md:col-span-2">
              <img src={Logo} alt="NOVA HLS" className="h-12 w-auto mb-4 filter invert brightness-200" />
              <p className="text-gray-400 mb-6">{t.footer.description}</p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/profile.php?id=61580402812403" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/nova.hls" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300">
                  <i className="fab fa-instagram"></i>
                </a>
                {/* <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300">
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-bold mb-4">{t.footer.services}</h3>
              <ul className="space-y-2">
                <li><a href="#uslugi" onClick={(e)=>handleSmoothScroll(e,'#uslugi')} className="text-gray-400 hover:text-white transition-colors">{t.services.plumbing.title}</a></li>
                <li><a href="#uslugi" onClick={(e)=>handleSmoothScroll(e,'#uslugi')} className="text-gray-400 hover:text-white transition-colors">{t.services.bathrooms.title}</a></li>
                <li><a href="#uslugi" onClick={(e)=>handleSmoothScroll(e,'#uslugi')} className="text-gray-400 hover:text-white transition-colors">{t.services.heating.title}</a></li>
                <li><a href="#uslugi" onClick={(e)=>handleSmoothScroll(e,'#uslugi')} className="text-gray-400 hover:text-white transition-colors">{t.services.electrical.title}</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold mb-4">{t.footer.company}</h3>
              <ul className="space-y-2">
                <li><a href="#onas" onClick={(e)=>handleSmoothScroll(e,'#onas')} className="text-gray-400 hover:text-white transition-colors">{t.nav.about}</a></li>
                <li><a href="#realizacje" onClick={(e)=>handleSmoothScroll(e,'#realizacje')} className="text-gray-400 hover:text-white transition-colors">{t.nav.projects}</a></li>
                <li><a href="#kontakt" onClick={(e)=>handleSmoothScroll(e,'#kontakt')} className="text-gray-400 hover:text-white transition-colors">{t.nav.contact}</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">{t.footer.hours}</h3>
              <ul className="space-y-2 text-gray-400">
                <li className="flex justify-between">
                  <span>Pon-Pt:</span>
                  <span>9:00-17:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Sobota:</span>
                  <span>9:00-13:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Niedziela:</span>
                  <span>Zamknięte</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold mb-4">Dane firmy</h3>
              <ul className="space-y-2 text-gray-400">
                <li>Adres: ul. Stanisławowska 47, 54-611 Wrocław, Polska</li>
                <li>NIP: 8943267784</li>
                <li>REGON: 54263627300000</li>
                <li>KRS: 0001191908</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} NOVA HLS. {t.footer.rights}</p>
          </div>
        </div>
      </footer>

      {/* Przycisk szybkiego powrotu na górę */}
      {isScrolled && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 w-12 h-12 bg-blue-600 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-700 transition-colors duration-300 z-30"
          aria-label="Powrót na górę"
        >
          <i className="fas fa-chevron-up"></i>
        </button>
      )}

      {/* Cookie Consent */}
      <CookieConsent
        location="bottom"
        buttonText="Akceptuj"
        cookieName="novaHLS-cookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ background: "#3b82f6", color: "white", fontSize: "14px", borderRadius: "4px" }}
        expires={150}
      >
        Ta strona używa plików cookies w celu poprawienia jakości korzystania z serwisu.{" "}
        <span style={{ fontSize: "12px" }}>
          <a href="#/polityka-prywatnosci" className="text-blue-300 hover:text-blue-100"> {/* ZMIANA: #/polityka-prywatnosci */}
            Dowiedz się więcej
          </a>
        </span>
      </CookieConsent>

            {isLightboxOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4">
          <button 
            onClick={closeLightbox}
            className="absolute top-6 right-6 text-white text-3xl z-50 hover:text-blue-400 transition-colors"
            aria-label="Zamknij"
          >
            <i className="fas fa-times"></i>
          </button>
          
          <button 
            onClick={() => navigateLightbox('prev')}
            className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white text-2xl bg-black bg-opacity-50 p-4 rounded-full hover:bg-opacity-70 transition-all z-50"
            aria-label="Poprzednie zdjęcie"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          
          <button 
            onClick={() => navigateLightbox('next')}
            className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white text-2xl bg-black bg-opacity-50 p-4 rounded-full hover:bg-opacity-70 transition-all z-50"
            aria-label="Następne zdjęcie"
          >
            <i className="fas fa-chevron-right"></i>
          </button>
          
          <div className="relative max-w-6xl max-h-full w-full h-full flex items-center justify-center">
            <img 
              src={currentLightboxImage} 
              alt="Powiększone zdjęcie"
              className="max-w-full max-h-full object-contain"
            />
            
            {/* Miniatury na dole */}
            <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2">
              {lightboxImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Miniatura ${index + 1}`}
                  className={`w-16 h-12 object-cover cursor-pointer rounded border-2 transition-all ${
                    image === currentLightboxImage ? 'border-blue-500 scale-110' : 'border-transparent opacity-70 hover:opacity-100'
                  }`}
                  onClick={() => setCurrentLightboxImage(image)}
                />
              ))}
            </div>
            
            {/* Numeracja */}
            <div className="absolute top-6 left-6 text-white text-lg">
              {lightboxImages.indexOf(currentLightboxImage) + 1} / {lightboxImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;